// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--2XoXm","bannertext":"banner-module--bannertext--1gbW3","bannerimg":"banner-module--bannerimg--sokaT"};